"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _without2 = _interopRequireDefault(require("lodash/without"));
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _order = require("./order.store");
var _downloadOrderPdf = require("./download-order-pdf.store");
var _activityProduct = require("../factories/activity-product.factory");
var _constants = require("../constants");
var _sale = require("./sale.store");
var _sale2 = require("../utils/sale.utils");
var _saleFactory = require("../factories/sale-factory");
var _class;
/**
 * ManageActivityBookingPage
 */
let ActivityBookingStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function ActivityBookingStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, ActivityBookingStore);
    this.$env = $env;
    this.updateInitialState(initialState);
    this.order = new _order.OrderStore(initialState.order, $env, _activityProduct.activityProductFactory);
    this.orderPdf = new _downloadOrderPdf.DownloadOrderPdfStore(initialState.orderPdf, $env);
    this.sale = new _sale.MyAccountSaleStore(initialState.sale, $env);
  }

  /**
   * Activity Product
   * @return {Object}
   */
  (0, _createClass2.default)(ActivityBookingStore, [{
    key: "activity",
    get: function () {
      var _this$sale$data$booki;
      const bookings = (_this$sale$data$booki = this.sale.data.bookings) === null || _this$sale$data$booki === void 0 ? void 0 : _this$sale$data$booki.map(booking => (0, _saleFactory.saleFactory)(booking, this.$env));
      const activity = bookings === null || bookings === void 0 ? void 0 : bookings.filter(booking => booking.type === _constants.PRODUCT_TYPES.ACTIVITY)[0];
      return activity;
    }

    /**
     * display status
     * @return {number}
     */
  }, {
    key: "displayStatus",
    get: function () {
      var _this$activity;
      return (_this$activity = this.activity) === null || _this$activity === void 0 ? void 0 : _this$activity.displayStatus;
    }

    /**
     * is processing
     * @return {boolean}
     */
  }, {
    key: "isProcessing",
    get: function () {
      return _constants.ALL_PRODUCT_BOOKING_STATUS.IN_PROGRESS === this.displayStatus;
    }
  }, {
    key: "skusPrices",
    get: function () {
      var _this$activity2, _this$activity2$produ;
      return (_this$activity2 = this.activity) === null || _this$activity2 === void 0 ? void 0 : (_this$activity2$produ = _this$activity2.product) === null || _this$activity2$produ === void 0 ? void 0 : _this$activity2$produ.skusPrices;
    }

    /**
     * is confirmed
     * @return {boolean}
     */
  }, {
    key: "isConfirmed",
    get: function () {
      return _constants.ALL_PRODUCT_BOOKING_STATUS.CONFIRMED === this.displayStatus;
    }

    /**
     * is complete
     * @return {boolean}
     */
  }, {
    key: "isComplete",
    get: function () {
      return _constants.ALL_PRODUCT_BOOKING_STATUS.COMPLETED === this.displayStatus;
    }

    /**
     * is cancelled
     * @return {boolean}
     */
  }, {
    key: "isCancelled",
    get: function () {
      return [_constants.ALL_PRODUCT_BOOKING_STATUS.CANCELLED_NOT_REFUNDED, _constants.ALL_PRODUCT_BOOKING_STATUS.CANCELLED_REFUNDED].includes(this.displayStatus);
    }

    /**
     * is Failed
     * @return {boolean}
     */
  }, {
    key: "isFailed",
    get: function () {
      return [_constants.ALL_PRODUCT_BOOKING_STATUS.CANCELLED_NOT_REFUNDED, _constants.ALL_PRODUCT_BOOKING_STATUS.CANCELLED_REFUNDED].includes(this.displayStatus);
    }

    /**
     * has ETicket
     * @return {boolean}
     */
  }, {
    key: "hasVoucher",
    get: function () {
      return this.isConfirmed;
    }

    /**
     * voucher link
     * @return {boolean}
     */
  }, {
    key: "voucherLink",
    get: function () {
      var _this$orderPdf$activi;
      return (_this$orderPdf$activi = this.orderPdf.activityVoucherUrl) !== null && _this$orderPdf$activi !== void 0 ? _this$orderPdf$activi : 'https://tjwlcdn.com/activities/icons/show_mobile_or_printed_voucher.png';
    }

    /**
     * has Invoice
     * @return {boolean}
     */
  }, {
    key: "hasInvoice",
    get: function () {
      return this.isConfirmed;
    }

    /**
     *  Invoice link
     * @return {boolean}
     */
  }, {
    key: "invoiceLink",
    get: function () {
      var _this$orderPdf$activi2;
      return (_this$orderPdf$activi2 = this.orderPdf.activityInvoice) !== null && _this$orderPdf$activi2 !== void 0 ? _this$orderPdf$activi2 : 'https://tjwlcdn.com/activities/icons/show_mobile_or_printed_voucher.png';
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }

    /**
     * @typedef {Object} Reward
     * @property {number} value
     * @property {number} points
     * @property {Date} expiryDate
     * @property {string} method
     * @property {string} identifier
     *
     * reward
     * @return {Reward}
     */
  }, {
    key: "reward",
    get: function () {
      const reward = (0, _sale2.getSaleReward)(this.sale);
      return reward;
    }
  }]);
  return ActivityBookingStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "activity", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "activity"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayStatus"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isProcessing", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isProcessing"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "skusPrices", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "skusPrices"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isConfirmed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isConfirmed"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isComplete", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isComplete"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isCancelled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCancelled"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFailed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFailed"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasVoucher", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasVoucher"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "voucherLink", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "voucherLink"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasInvoice", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasInvoice"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "invoiceLink", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "invoiceLink"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reward"), _class.prototype)), _class);
exports.default = ActivityBookingStore;